import Component from '../components/Component'

import Auth from '../Auth'
import {AuthContext} from "../providers/AuthProvider";

export default class Page extends Component
{


    //contextType of the component is AuthContext. i.e this.context.auth = TB auth user
    static contextType = AuthContext;
    static middleware(props)
    {
        let redirect;
        if (!Auth.isAppropriate(props.location)) {
            // redirect = Auth.appropriate();
            // console.log('Page @ middleware -> Restricted from navigation');
            // console.log(props.location);
            // console.log('Page @ middleware -> Redirecting to appropriate');
            // console.log(redirect);
        }

        if (redirect) {
            // props.history.push(redirect)
        }
        return redirect;
    }

    static BGClass = 'bg-light-blue';
    // static ShowChatWidget = false;
    static PageRequests = () => {
        return [

        ]
    }

    static events()
    {
        let pageEvents = {
            'Auth@expired': (component) => component.handleAuth(),
            'Auth@load': (component) => component.handleAuth(),
            'Auth@login': (component) => component.handleAuth(),
            'Auth@logout': (component) => component.handleAuth(),
            'Auth@update': (component) => component.handleAuth(),
            'Nav@back': (component) => component.back(),
        };

        let customEvents = {...this.handle};

        return {...pageEvents, ...customEvents};
    }

    static handle = {
        //
    };

    static path = '/';

    static options = {};

	componentDidMount()
	{
		super.componentDidMount();

        // if (this.constructor.ShowChatWidget) {
        //     this.showChatWidget();
        // }
        // else {
        //     this.hideChatWidget();
        // }




        // document.body.classList.remove('bg-gradient');
        // document.body.classList.remove('bg-light-blue');

        // document.body.classList.add(this.constructor.BGClass);
        // document.body.classList.add('bg-light-blue');
	}

    //
    // static getDerivedStateFromProps(props, state)
    // {
    //     // console.log('getDerivedStateFromProps', props, state);
    //
    //     TB.location = props.location;
    //
    //     return state;
    // }

    async loadedChatWidget()
    {
        let container = document.getElementById('drift-widget-container');

        if (!container) {
            await TB.wait(500);

            return this.loadedChatWidget();
        }

        return container;
    }

    // async showChatWidget()
    // {
    //     let auth = Auth.user();
    //     if (!auth) {
    //         return this.hideChatWidget();
    //     }
    //     let client = auth.clientOrg();
    //     if (!client) {
    //         return this.hideChatWidget();
    //     }
    //     let consultant = client.consultant();
    //     if (!consultant) {
    //         return this.hideChatWidget();
    //     }
    //     // if(!TB.isDefined(window.drift)) return;

    //     // drift.on('ready',function(api, payload) {
    //     //     api.widget.show()
    //     //     api.openChat()
    //     // });
    // }

    // async hideChatWidget()
    // {
    //     if(!TB.isDefined(window.drift)) return;
    //     drift.on('ready',function(api, payload) {
    //         api.widget.hide()
    //     });
    // }

    removeChatWidgetDefaultStyle()
    {
        let styleTags = document.getElementsByTagName('style');
        for (let i=0, max = styleTags.length; i < max; i++) {
            if (styleTags[i] && styleTags[i].id == 'hide-chat-widget-styler') {
                styleTags[i].parentNode.removeChild(styleTags[i]);
            }
        }
    }

    async handleAuth()
    {
        // console.log('Page @ handleAuth');

        // await this.promisedState({
        //     auth: this.context.auth,
        //     isChanged: false,
        // });

        if ((!this.context.auth || Auth.DidExpire)
            && this.constructor.PageRequests().length) {
            for (let request of this.constructor.PageRequests()) {
                if (request && request.isRunning()){
                    await request.cancel();
                }
            }
        }

        let redirect = Auth.intended();
        if (!this.props.location
            || !TB.auth().isAppropriate(this.props.location))
        {
            console.log('Page @ handleAuth -> redirect', redirect);
            if (this.props.history) {
                this.props.history.push(redirect);
            }
        }

        if (Auth.exists() && Auth.Intended) {
            Auth.Intended = undefined;
        }

        if (Auth.DidExpire) {
            // TB.alert(
            //     'error',
            //     TB.trans('api.server_error.title'),
            //     TB.trans('auth.expired')
            // );
        }
        // else if (this.constructor.ShowChatWidget) {
        //     await this.showChatWidget();
        // }
    }

    /**
     * Reset page state and components
     *
     * @returns void
     */
    reload()
    {
        let currentPath = window.location.pathname;

        this.props.history.push({ pathname: "/empty" });
        this.props.history.replace({ pathname: currentPath });

        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth'
        });
    }

    back()
    {
        return this.props.history.goBack();
    }

    queryParams() {
        return this.props.queryParams || {}
    }

    queryParam(key) {
        let value = this.queryParams()[key];
        if (!TB.isString(value)) {
            return value;
        }

        return value.trim();
    }

    hasQueryParam(key) {
        return this.queryParams().hasOwnProperty(key);
    }

    componentWillUnmount() {
        super.componentWillUnmount();
        if (this.constructor.PageRequests().length) {
            for (let request of this.constructor.PageRequests()) {
                if (request?.isRunning()){
                    request.cancel();
                }
            }
        }
    }
}